import React from 'react';
import { Scale, Calculator, Database, Award as AwardIcon, ShieldCheck, Trophy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocalizedData } from '../i18n/dataLoader';

const iconMap = { Scale, Calculator, Database, Award: AwardIcon, ShieldCheck, Trophy };

const Awards = () => {
  const { t } = useTranslation();
  const data = useLocalizedData('awards');
  const awards = data?.awards || [];
  const trustNumbers = data?.trustNumbers || [];
  return (
    <section id="auszeichnungen" className="py-20 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-[#b8893d] text-xs tracking-[0.3em] mb-3">{t('awards.eyebrow', 'AUSZEICHNUNGEN & MITGLIEDSCHAFTEN')}</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B3A5C]">{t('awards.headline', 'Zertifiziert. Anerkannt. Vertrauenswürdig.')}</h2>
        </div>

        {/* Trust numbers */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
          {trustNumbers.map((n) => (
            <div key={n.label} className="text-center p-6 bg-[#f5f8fa] rounded-sm border-b-2 border-[#b8893d]">
              <div className="font-serif text-3xl md:text-4xl text-[#b8893d] leading-none mb-2">{n.value}</div>
              <div className="text-[#34536b] text-xs tracking-wider uppercase">{n.label}</div>
            </div>
          ))}
        </div>

        {/* Awards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {awards.map((a) => {
            const Icon = iconMap[a.icon] || AwardIcon;
            return (
              <div
                key={a.id}
                className="group flex items-center gap-4 p-5 bg-[#f5f8fa] hover:bg-white border border-transparent hover:border-[#b8893d]/30 hover:shadow-md rounded-sm transition-all"
              >
                <div className="w-12 h-12 bg-[#1B3A5C] group-hover:bg-[#b8893d] rounded-sm flex items-center justify-center flex-shrink-0 transition-colors">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <div className="min-w-0">
                  <p className="text-[#1B3A5C] font-semibold text-sm leading-tight">{a.title}</p>
                  <p className="text-[#34536b] text-xs mt-1">{a.subtitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Awards;
